import styled from "styled-components";

const Wrapper = styled.div`
  .heading-row {
    margin-bottom: 16px;
  }

  .page-title {
    margin: 0;
  }

  .section-card {
    margin-top: 16px;
  }

  .alert-row {
    margin-bottom: 4px;
  }
`;

export default Wrapper;
